const totalItemCountStringDefault = (count: number) => (count === 1 ? 'track' : 'tracks');

export default totalItemCountStringDefault;
